import { useConnector, useInstantSearch } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';

import { Switch } from '@sorare/core/src/atoms/inputs/Switch';
import { SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { FilterTitle } from '@sorare/core/src/components/search/FilterTitle';
import type { ExtendedUIState } from '@sorare/core/src/components/search/InstantSearch/types';
import { connectExcludeFilter } from '@sorare/core/src/components/search/connectors/connectExcludeFilter';
import { useFacet } from '@sorare/core/src/contexts/graphql-search';
import { FILTERS } from '@sorare/core/src/lib/filters';
import { filters } from '@sorare/core/src/lib/glossary';

const FILTER = FILTERS.collectible;
const BACKEND_COLLECTIBLE_KEY = 'co';
const CollectibleFilter = () => {
  const { value, refine } = useConnector(connectExcludeFilter, {
    facet: 'rarity',
    excluded: 'custom_series',
    searchParam: FILTER.alias,
  });

  return (
    // oxlint-disable-next-line jsx-a11y/label-has-associated-control
    <label className="FilterWidget visible">
      <SBHorizontal>
        <FormattedMessage {...FILTER.title} />
        <Switch
          checked={value}
          onChange={e => {
            refine(e.target.checked);
          }}
        />
      </SBHorizontal>
    </label>
  );
};

const Title = () => {
  const {
    indexUiState: { exclusions: { [FILTER.alias]: filterChecked } = {} },
  } = useInstantSearch<ExtendedUIState>();

  return (
    <FilterTitle
      name={filters.collectibleFilterTitle}
      selected={filterChecked ? 1 : 0}
    />
  );
};

export const widget = {
  key: FILTER.alias,
  attribute: '',
  type: 'toggle' as const,
  title: <Title />,
  Component: CollectibleFilter,
};

const BackendCollectibleFilter = () => {
  const { value, refine } = useFacet(BACKEND_COLLECTIBLE_KEY);
  const isRefined = !!value.length;

  return (
    // oxlint-disable-next-line jsx-a11y/label-has-associated-control
    <label className="FilterWidget visible">
      <SBHorizontal>
        <FormattedMessage {...FILTER.title} />
        <Switch
          checked={isRefined}
          onChange={e => {
            refine(() => (e.target.checked ? ['true'] : []));
          }}
        />
      </SBHorizontal>
    </label>
  );
};

const BackendTitle = () => {
  const { value } = useFacet(BACKEND_COLLECTIBLE_KEY);
  return (
    <FilterTitle
      name={filters.collectibleFilterTitle}
      selected={value.length ? 1 : 0}
    />
  );
};

export const backendWidget = {
  key: `${FILTER.alias}_backend`,
  attribute: BACKEND_COLLECTIBLE_KEY,
  type: 'toggle' as const,
  title: <BackendTitle />,
  Component: BackendCollectibleFilter,
};
